import Pointer from "poin"
import * as Preact from "preact"
import {nanoid} from "nanoid"
import Objdict from "objdict"
import isString from "@fae/source/utility/isString.js"

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"
import SequenceAnimation from "@fae/source/engine/animating/SequenceAnimation.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
import Unit from "@fae/source/models/Unit.js"
import Stage from "@fae/source/models/Stage.js"
import SkillPreview from "@fae/source/views/components/SkillPreviewUI.jsx"
import Passive from "@fae/source/data/games/ember/views/Passive.jsx"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"
import Chapter from "@fae/source/models/Chapter.js"
import unitJobs from "@fae/source/data/unitJobs.js"
import skills from "@fae/source/data/skills.jsx"
import unitSprites from "@fae/source/data/unitSprites.js"
import elements from "@fae/source/data/elements.js"
import games from "@fae/source/data/games/index.js"
import Geometry from "@fae/source/utility/Geometry.js"

import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@fae/source/views/components/UnitExperienceBar.jsx"
import DialogueLog from "@fae/source/views/components/DialogueLog.jsx"
import Portrait from "@fae/source/views/components/Portrait.jsx"
import "@fae/source/views/ChapterUI.less"
import pretty from "pretty-ms"

export default class ChapterUI {
    render() {
        if(App.options.disableHUD == true) return
        const stage = this.props.stage
        // return false
        // isInModal={this.props.stage?.dialogue != undefined}
        return (
            <div class="ChapterUI" phase={this.props.stage.player.phase}>
                <Buttons stage={stage}/>
                <UnitSummary stage={stage}/>

                <ChapterPrompt stage={stage}/>
                <BossStatus stage={stage}/>
            </div>
        )
        // <DialogueLog stage={stage}/> // put me back in!!
        // <ElementalTriangle/>
        // <Inventory stage={stage}/>
        // <Tutorial stage={stage}/>
        // <EncounterName stage={stage}/>
        // <EncounterDetails stage={stage}/>
        // <EncounterText stage={stage}/>
        // <PrepareModal/>
    }
}

class BossStatus {
    render() {
        return (
            <div class="BossStatuses">
                {Object.values(this.props.stage.units).filter((unit) => {
                    return unit.properties != undefined
                        && unit.properties.includes("boss")
                        && Geometry.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey], unit.position)
                }).map((unit) => {
                    return (
                        <div class="BossStatus" isDead={unit.isDead}>
                            <div class="Label">
                                <span class="Title">
                                    {unit.title || unit.name}
                                </span>
                                <span class="Subtitle">
                                    ({unit.subtitle || unit.jobName}{unit.level && " Lv" + unit.level})
                                </span>
                            </div>
                            <div class="HealthBar">
                                <UnitHealthBar unit={unit} omegaunit={App.game.chapter.selection?.hoveredAction?.omegastage?.units[unit.key]}/>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

class ElementalTriangle {
    render() {
        return (
            <div class="ElementalTriangle">
                <div class="Sword"><div class="Icon"/></div>
                <div class="Spear"><div class="Icon"/></div>
                <div class="Axe"><div class="Icon"/></div>
            </div>
        )
    }
}

class ChapterPrompt {
    render() {
        if(this.props.stage.dialogue != undefined
        || this.props.stage.turn.affiliation != this.props.stage.player.affiliation) {
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        }

        const text = this.text
        if(text == undefined) return
        if(isString(text) == true) {
            return (
                <div class="TutorialPrompt" position="topright">
                    <div class="Text">
                        {text}
                    </div>
                </div>
            )
        } else {
            return text
        }
    }
    get text() {
        if(this.props.stage.hud instanceof Function) {
            return this.props.stage.hud(this.props.stage)
        } else {
            return this.props.stage.hud
        }
    }
}

class EncounterName {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.currentEncounterKey == undefined) return
        if(stage.encounters[stage.currentEncounterKey] == undefined) return
        if(stage.encounters[stage.currentEncounterKey]?.name == undefined) return

        return (
            <div class="EncounterName">
                {stage.encounters[stage.currentEncounterKey]?.name}
            </div>
        )
    }
}

class Buttons {
    render() {
        // if(App.game.chapter.phase != "play") return
        if(App.game.chapter.hasUndoEndTurnButtons === false) return
        if(this.props.stage?.flags["hud"] == "hidden") return

        // App.game.key == "ember" && App.game.chapter.previousStages.length == 0 ? (
        //     <div class="UndoButton" onClick={this.onReroll} gameKey={App.game.key} isUsable={this.isUsable && this.props.stage.player.rollcount > 0}>
        //         <div class="Text">Reroll ({this.props.stage.player.rollcount}x)</div>
        //     </div>
        // ) : (
        //     <div class="UndoButton" onClick={this.onUndo} gameKey={App.game.key} isUsable={this.isUsable}>
        //         <div class="Text">Undo</div>
        //         <div class="Shortcut">{App.mode == "gamepad" ? "(bumper)" : "z"}</div>
        //         <div class="Handle"/>
        //     </div>
        // )

        const canReroll = (this.props.stage.player.rollcount > 0 && App.game.chapter.previousStages.length == 0)

        return [
            <div class="EndTurnGlow" isAttentionGrabbing={this.isAttentionGrabbing} isVisible={this.isUsable("endturn")}>
                <div class="Animation"/>
            </div>,
            <div class="EndTurnButton" onClick={this.onEndTurn} isAttentionGrabbing={this.isAttentionGrabbing} gameKey={App.game.key} isUsable={this.isUsable("endturn")}>
                <div class="Text">
                    <span class="Big">End</span><br/>Turn
                </div>
                <div class="Shortcut">{App.mode == "gamepad" ? "(y)" : "enter"}</div>
                <div class="Charge" style={{"width": Math.min(100, App.game.chapter.selection.charge / App.game.chapter.selection.maxcharge * 100).toFixed(2) + "%"}}/>
            </div>,
            // <div class="RerollButton" onClick={this.onReroll} gameKey={App.game.key} isUsable={this.isUsable("reroll") && canReroll} isActive={App.game.chapter.selection.isRerolling}>
            //     <div class="Text">Reroll {this.props.stage.player.rollcount}x</div>
            // </div>
            // <div class="UndoButton" onClick={this.onUndo} gameKey={App.game.key} isUsable={this.isUsable("undo")}>
            //     <div class="Text">Undo</div>
            //     <div class="Shortcut">{App.mode == "gamepad" ? "(bumper)" : "z"}</div>
            // </div>,

            // TODO: Only use this for ember. Move into chapter hud.
            App.game.chapter.previousStages.length == 0 ? (
                <div class="UndoButton" onClick={this.onReroll} gameKey={App.game.key} isUsable={this.isUsable("reroll") && canReroll} isActive={App.game.chapter.selection.isRerolling}>
                    <div class="Text">Reroll {this.props.stage.player.rollcount}x</div>
                </div>
            ) : (
                <div class="UndoButton" onClick={this.onUndo} gameKey={App.game.key} isUsable={this.isUsable("undo")}>
                    <div class="Text">Undo</div>
                    <div class="Shortcut">{App.mode == "gamepad" ? "(bumper)" : "z"}</div>
                </div>
            )
        ]
    }
    isUsable(buttonType) {
        if(buttonType == "endturn" || buttonType == "undo") {
            if(App.game.chapter.selection.isRerolling == true) return false
        }
        return this.props.stage.dialogue == undefined
            && this.props.stage.turn.affiliation == this.props.stage.player.affiliation
            && this.props.stage.player.phase != "rolling"
    }
    get isAttentionGrabbing() {
        // return false // debug, disabling for now

        // Has the player won?
        if(this.hasWon == true) return true

        // Have all player units taken actions?
        const allies = Object.values(this.props.stage.units).filter((unit) => {
            return unit.isDead != true && unit.isRemoved != true
                && Geometry.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey], unit.position)
                && unit.affiliation == this.props.stage.player.affiliation
        })
        if(allies.length > 0) {
            return allies.length == allies.filter((unit) => unit.energy["move"] != true && unit.energy["act"] != true).length
        }
    }
    get hasWon() {
        return this.props.stage.scripts?.find((condition) => {
            return condition.isWinCondition == true
                && condition.condition instanceof Function == true
                && condition.condition(this.props.stage) == true
        }) != undefined
    }
    get onUndo() {
        return (event) => {
            event.stopPropagation()
            if(this.isUsable("undo") == false) return
            App.game.chapter.actionTrace.push({"type": "undoAction"})
            Dev.recordSavestate("livePlaytest")
            App.game.chapter.undoAction()
        }
    }
    get onReroll() {
        return (event) => {
            event.stopPropagation()
            if(App.game.chapter.selection.isRerolling == true) {
                App.game.chapter.selection.isRerolling = false
                // Stage.calculateActions(App.game.chapter.stage, {"force": true})
            } else {
                App.game.chapter.selection.isRerolling = true
            }
        }
    }
    get onEndTurn() {
        return (event) => {
            if(this.isUsable("endturn") == false) return
            if(SequenceAnimation.isPerforming == true) return
            event.stopPropagation()
            const chapter = App.game.chapter
            const randomSeed = nanoid()
            chapter.runningDeltastageSubsum = {}
            chapter.endPlayerTurn(chapter.stage, {"seed": randomSeed})
            chapter.actionTrace.push({
                "type": "endTurn",
                "seed": randomSeed,
                "deltastageSum": chapter.runningDeltastageSubsum
            })
        }
    }
}

class UnitSummary {
    render() {
        if(this.props.stage?.dialogue != undefined) return

        const selection = App.game.chapter.selection
        const selectedUnitKey = selection.selectedUnitKey || selection.hoveredUnitKey
        const selectedUnit = this.props.stage.units[selectedUnitKey]

        if(selection.hoveredAction?.type == "act") {
            const targetUnit = Stage.findUnitByPosition(this.props.stage, selection.hoveredAction.position)
            return (
                <div class="UnitSummary">
                    <UnitDetails unit={selectedUnit} stage={this.props.stage} position={"left"}/>
                    <UnitDetails unit={targetUnit} stage={this.props.stage} position={"right"}/>
                </div>
            )
        }
        if(selection.selectedUnitKey != undefined || selection.hoveredUnitKey != undefined) {
            return (
                <div class="UnitSummary">
                    <UnitDetails unit={selectedUnit} position={selectedUnit?.affiliation == this.props.stage.player.affiliation ? "left" : "right"} stage={this.props.stage}/>
                </div>
            )
        }

        // const terrain = this.props.stage.world.terrain
        // return (
        //     <div class="UnitSummary">
        //         <div class="TerrainDetails" position="right">
        //             <div class="Label">
        //                 Diff
        //             </div>
        //         </div>
        //     </div>
        // )
    }
}

const MOVE_ACTION = {
    "title": "Move",
    "icon": require("@fae/source/assets/images/dice-tactics/actions/boot-kick.png"),
    "description": "Move **N** tiles orthogonally"
}

class UnitDetails {
    render() {
        if(this.props.unit == undefined) return
        // if((this.props.unit.type == "zone" || this.props.unit.type == "spot") && this.props.unit.role != "tree") return

        const unit = this.props.unit
        const omegaunit = App.game.chapter.selection?.hoveredAction?.omegastage?.units[unit.key]
        const element = elements[unit.element]
        const isSelected = this.props.unit.key == App.game.chapter.selection.selectedUnitKey

        // {false && <div class="MovementDice"
        //     canSelect={App.game.chapter.selection.activeUnit.energy["move"] != false}
        //     onMouseUp={(event) => event.stopPropagation()}
        //     onMouseDown={(event) => event.stopPropagation()}>
        //     <Dice item={MOVE_ACTION} unit={unit} stage={this.props.stage} anchored="top"/>
        // </div>}
        // <div class="Stats">
        //     <div class="Health">
        //         <div class="Value">{unit.health}/{unit.maxhealth}</div>
        //         <div class="Label">HP</div>
        //     </div>
        // </div>
        // {this.skillPreview(skillKey)}
        return (
            <div class="UnitDetails" key={unit?.key} position={this.props.position} isSelected={isSelected} hasPortrait={this.portrait != undefined ? "yes" : "no"}>
                <div class="Profile">
                    <div class="Summary" side={"bottom-" + this.props.position}>
                        <div class="PortraitFrame">
                            {this.portrait}
                        </div>
                        <div class="Description">
                            {(unit.title || unit.name) && (<div class="Name">
                                <span class="Text">
                                    {unit.title || unit.name}
                                </span>
                            </div>)}
                            {(unit.subtitle || unit.jobName) && (<div class="Class">
                                <span class="Text">
                                    {(unit.subtitle || unit.jobName)?.split("\n").map((line) => <span>{line}</span>)} {unit.level && "Lv" + unit.level}
                                </span>
                            </div>)}
                            {(unit.flavor) && (<div class="Flavor">
                                <span class="Text">
                                    {unit.flavor}
                                </span>
                            </div>)}
                        </div>
                        <div class="Status">
                            <UnitHealthBar unit={unit} omegaunit={omegaunit}/>
                        </div>
                    </div>
                </div>
                <div class="Actions" side={"bottom-" + this.props.position}>
                    {this.actions}
                </div>
                <div class="Passives" side={"bottom-" + this.props.position}>
                    {Unit.passives(unit).map((passive) => {
                        return (
                            <Passive passive={passive} unit={unit} stage={this.props.stage}/>
                        )
                    })}
                </div>
            </div>
        )
    }
    skillPreview(skillKey) {
        if(App?.game?.demoes != undefined
        && App?.game?.demoes[skillKey] != undefined
        && App?.game?.chapter?.selection?.hoveredSkillKey == skillKey) {
            return <SkillPreview demo={App.game.demoes[skillKey]}/>
        }
    }
    get actions() {
        const unit = this.props.unit
        const stage = this.props.stage
        const items = Unit.items({stage, unit})
        if(this.props.stage.player?.phase == "rolling" || App.game.chapter.selection.isRerolling == true) {
            return (
                <DiceLayout unit={unit} stage={this.props.stage} anchored="top"/>
            )
        }
        const actions = []
        Object.values(items || []).forEach((item) => {
            if(item == undefined) return
            if(this.props.stage?.configuration?.useEquippedItemOnly == true && item != unit.equippedItem) return
            if(unit.affiliation != this.props.stage.player.affiliation && item != unit.equippedItem) return
            actions.push(
                <div class="EquippedDice"
                    canSelect={App.game.chapter.selection.activeUnit.energy["act"] != false}
                    isSelected={App.game.chapter.selection.isSelectedItemSkill(item, item?.skillKeys && item.skillKeys[0])}
                    onClick={this.onClickItemSkill(unit.equippedItem, item?.skillKeys && item.skillKeys[0])} // TODO: handle multiple skills
                    onMouseOver={(event) => {App.game.chapter.selection.hoveredItem = item; App.game.chapter.selection.hoveredSkillKey = item?.skillKeys && item.skillKeys[0]}}
                    onMouseOut={(event) => {App.game.chapter.selection.hoveredItem = undefined; App.game.chapter.selection.hoveredSkillKey = undefined}}
                    onMouseUp={(event) => event.stopPropagation()}
                    onMouseDown={(event) => event.stopPropagation()}>
                    <Dice item={item} unit={unit} stage={stage} anchored="top"/>
                </div>
            )
        })
        if(unit.affiliation == this.props.stage.player.affiliation) {
            Object.values(unit.skillKeys).forEach((skillKey, index) => {
                const skill = skills[skillKey]
                if(skill == undefined) return
                if(skill.isHidden instanceof Function) {
                    if (skill.isHidden({"stage": this.props.stage, "performerKey": unit.key}) == true) return
                } else {
                    if (skill.isHidden == true) return
                }
                const item = {
                    "skillKeys": [skillKey],
                    "title": skill.name || skillKey,
                    "iconKey": skill.iconKey || "shrug",
                    "element": "null",
                    "power": skill.power,
                    "isSmall": true,
                    "description": skill.description || "Does something.",
                }
                actions.push(
                    <div class="EquippedDice"
                        canSelect={App.game.chapter.selection.activeUnit.energy["act"] != false}
                        isSelected={App.game.chapter.selection.isSelectedSkill(skillKey)}
                        onClick={this.onClickSkill(skillKey)}
                        onMouseOver={(event) => App.game.chapter.selection.hoveredSkillKey = skillKey}
                        onMouseOut={(event) => App.game.chapter.selection.hoveredSkillKey = undefined}
                        onMouseUp={(event) => event.stopPropagation()}
                        onMouseDown={(event) => event.stopPropagation()}>
                        <Dice item={item} unit={unit} stage={stage} anchored="top"/>
                    </div>
                )
            })
        }
        return actions
    }
    onClickItemSkill(item, skillKey) {
        return (event) => {
            const RIGHT_CLICK = 2
            if(event.button == RIGHT_CLICK) return
            if(App.game.chapter.selection.selectedItem != item
            || App.game.chapter.selection.selectedSkillKey != skillKey) {
                App.game.chapter.selection.selectedItem = item
                App.game.chapter.selection.selectedSkillKey = skillKey

                const skill = skills[skillKey]
                if(skill.role == "equip") {
                    const unit = this.props.unit
                    const action = unit.actionmap[unit.position.x + "x" + unit.position.y]?.find((action) => {
                        return action.item == item
                            && action.skillKey == skillKey
                    })
                    if(action == undefined) return
                    const omegastage = App.game.chapter.performAction(action)

                    App.game.chapter.selection.selectedItem = undefined
                    App.game.chapter.selection.selectedUnitKey = undefined
                    App.game.chapter.selection.selectedSkillKey = undefined
                    App.game.chapter.selection.selectedSubclassIndex = undefined
                    Audiomix.trigger("Selection:Finish")
                }
            } else {
                App.game.chapter.selection.selectedItem = undefined
                App.game.chapter.selection.selectedSkillKey = undefined
            }
        }
    }
    onClickSkill(skillKey) {
        return (event) => {
            if(App.game.chapter.selection.selectedSkillKey != skillKey) {
                App.game.chapter.selection.selectedSkillKey = skillKey
                App.game.chapter.selection.selectedItem = undefined
            } else {
                App.game.chapter.selection.selectedSkillKey = undefined
                App.game.chapter.selection.selectedItem = undefined
            }
        }
    }
    get portrait() {
        const unit = this.props.unit
        if(unit == undefined) return

        let expression = "neutral"
        if(App.game.chapter.selection?.hoveredAction?.type == "act"
        && skills[App.game.chapter.selection?.hoveredAction?.skillKey].role == "damage") {
            if(App.game.chapter.selection.selectedUnitKey == unit.key) {
                expression = "attack"
            } else if(Stage.findUnitByPosition(this.props.stage, App.game.chapter.selection?.hoveredAction.position)?.key == unit.key) {
                expression = "hurt"
            }
        }

        if(unit.portraits == undefined) return
        const portrait = unit.portraits[unit.portraitKey] || unit.portraits[expression] || unit.portraits["neutral"]
        return <Portrait portrait={portrait} anchor={unit.portraitAnchor}/>
    }
}
